import React, {PropTypes} from 'react';
import { connect } from 'react-redux'
import { message } from 'antd';
import { push, goBack } from 'react-router-redux'

// LOCAL
import { sendDataExportEnterprise, getEnterpriseMember, removeMember } from './actions'
import MemberMainContent from './MemberMainContent'
import onMount from '../../core/onMount'

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch, // needed for onMount HOC
    handleSendReport: (data)=> dispatch(sendDataExportEnterprise(ownProps.match.params.token_id, data)),
    onDateChange: (selectedDates)=> {
      dispatch({type:"SELECT_DATES", selectedDates})
      dispatch(getEnterpriseMember(ownProps.match.params.token_id, selectedDates))
    },
    onClickGetReport: (context_user_email) => {
      dispatch({type:"GET_MEMBER_REPORT_CLICKED", context_user_email})
      dispatch(push("/teams/data-exports/new"))
    },
    onFileTypeChange: (file_type)=> {
      dispatch({type:"SELECTED_FILE_TYPE", file_type})
    },
    onRemove: ()=> dispatch(removeMember(ownProps.match.params.token_id)).then(()=>message.success('Removed user successfully', 3)),
    getEnterpriseMember: (selectedDates)=> dispatch(getEnterpriseMember(ownProps.match.params.token_id, selectedDates)),
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userProfile: state.enterprise.members.selectedMember,
    mType: state.models.user.kms_enabled ? "kms" : "miles",
    selectedDates: state.enterprise.selectedDates,
    file_type: state.enterprise.file_type,
    kms_enabled: state.models.user.kms_enabled,
    isFetching: state.enterprise.members.isFetching
  }
}

const MountedMember = onMount(({dispatch, match}) => {
  dispatch(getEnterpriseMember(match.params.token_id));
})(MemberMainContent)


export default connect(mapStateToProps, mapDispatchToProps)(MountedMember)



// WEBPACK FOOTER //
// ./src/enterprise/members/Member.js